import { FC } from 'react';
import styled from 'styled-components';

export const TabApi: FC = () => {
  return <Container>api</Container>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
